import React from 'react';
import './FilterButton1.css';

const TypeFilter = ({ typeFilters, activeTypeFilter, handleClickTypeFilter }) => {
  return (
    <div id="filter-buttons" className="d-flex justify-content-center align-items-center" data-aos="fade-up" data-aos-delay="100">
      <h3 className="mr-3">Type:</h3>
      <ul className="list-unstyled d-flex mb-0">
        {typeFilters.map((filter, index) => (
          <li key={index} className={activeTypeFilter === filter ? 'active' : ''} onClick={() => handleClickTypeFilter(filter)}>
            {filter}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TypeFilter;
